const transformString = (value) => {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
}

export { transformString };